// extracted by mini-css-extract-plugin
module.exports = {"full":"PersonName__full__2xA65","abbreviated":"PersonName__abbreviated__1h0eu"};